import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	name: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	popularity: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	owner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	access: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editors: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyFilterResultMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterResultsAnnouncement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aToZOrder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	zToAOrder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	starredToUnstarredOrder: {
		id: string;
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: string;
		description: string;
	};
	unstarredToStarredOrder: {
		id: string;
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: string;
		description: string;
	};
	lowestToHighestOrder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	highestToLowestOrder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	name: {
		id: 'directories.dashboards-v2.main.name',
		defaultMessage: 'Name',
		description: 'Caption for the column heading for displaying dashboard name',
	},
	popularity: {
		id: 'directories.dashboards-v2.main.popularity',
		defaultMessage: 'Starred by',
		description:
			'Caption for the column heading for displaying dashboard popularity (favorites count)',
	},
	owner: {
		id: 'directories.dashboards-v2.main.owner',
		defaultMessage: 'Owner',
		description: 'Caption for the column heading for displaying the info about dashboard owner',
	},
	access: {
		id: 'directories.dashboards-v2.main.access',
		defaultMessage: 'Access',
		description: 'Caption for the column heading for displaying the info about access group',
	},
	viewers: {
		id: 'directories.dashboards-v2.main.viewers',
		defaultMessage: 'Viewers',
		description: 'Caption for the column heading for displaying the info about viewers group',
	},
	editors: {
		id: 'directories.dashboards-v2.main.editors',
		defaultMessage: 'Editors',
		description: 'Caption for the column heading for displaying the info about editors group',
	},
	emptyFilterResultMessage: {
		id: 'directories.dashboards-v2.main.empty-filter-result-message',
		defaultMessage: 'No dashboards were found that match your search',
		description:
			"Message to be displayed when user tried to filter results but their filtering criteria didn't match any",
	},
	tableAriaLabel: {
		id: 'directories.dashboards-v2.main.table-aria-label',
		defaultMessage: 'Dashboards details',
		description:
			'Message to be used as aria-label of dashboards table. The aria-label is announced by screen readers and helps users who use them understand the purpose of table',
	},
	filterResultsAnnouncement: {
		id: 'directories.dashboards-v2.main.filter-results-announcement',
		defaultMessage:
			'{itemCount, plural, =0 {No dashboards were found that match your search} one {{itemCount} dashboard found} other {{itemCount} dashboards found}}',
		description:
			'Message for screen reader users to announce how many dashboards were found after filtering',
	},
	moreActions: {
		id: 'directories.dashboards-v2.main.more-actions',
		defaultMessage: 'More actions',
		description: 'Caption for the column heading for displaying the more actions buttons',
	},
	aToZOrder: {
		id: 'directories.dashboards-v2.main.a-to-z-order',
		defaultMessage: 'Sort A to Z',
		description:
			'Ascending order used for the sort button toolip for a column which contains text or names',
	},
	zToAOrder: {
		id: 'directories.dashboards-v2.main.z-to-a-order',
		defaultMessage: 'Sort Z to A',
		description:
			'Descending order used for the sort button toolip for a column which contains text or names',
	},
	starredToUnstarredOrder: {
		id: 'directories.dashboards-v2.main.starred-to-unstarred-order',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Sort starred to unstarred',
		description:
			'Ascending order used for the sort button toolip for a column which contains favorited and unfavorited star icons',
	},
	unstarredToStarredOrder: {
		id: 'directories.dashboards-v2.main.unstarred-to-starred-order',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Sort unstarred to starred',
		description:
			'Descending order used for the sort button toolip for a column which contains favorited and unfavorited star icons',
	},
	lowestToHighestOrder: {
		id: 'directories.dashboards-v2.main.lowest-to-highest-order',
		defaultMessage: 'Sort lowest to highest',
		description:
			'Ascending order used for the sort button toolip for a column which contains numbers',
	},
	highestToLowestOrder: {
		id: 'directories.dashboards-v2.main.highest-to-lowest-order',
		defaultMessage: 'Sort highest to lowest',
		description:
			'Descending order used for the sort button toolip for a column which contains numbers',
	},
});
export default messages;
